import { Minus } from "@/components/svg";
import classNames from "classnames";

export default function MinusButton({
  onClick,
  alt = false,
  strokeAlt = undefined,
  title = "Remove",
  className,
  ...props
}) {
  const bgClasses = alt
    ? "bg-transparent hover:bg-dark-purple"
    : "bg-dark-purple hover:bg-light-purple";
  const borderClasses = alt
    ? "border border-light-purple hover:border-dark-purple"
    : "border border-transparent";
  const strokeClasses = strokeAlt
    ? "stroke-light-purple hover:stroke-white"
    : alt
    ? "stroke-light-purple hover:stroke-white"
    : "stroke-white";

  return (
    <div
      className={classNames(
        "rounded-full group flex items-center my-auto",
        borderClasses,
        bgClasses,
        "w-[24px] h-[24px] hover:cursor-pointer",
        className
      )}
      title={title}
      onClick={onClick}
      {...props}
    >
      <Minus className={classNames("mx-auto w-3/4", strokeClasses)} />
    </div>
  );
}
